import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.ivory,
  secondaryBgColor: colors.white,
  cardRadius: '20px',
  textColorDark: colors.darkNight,
  textColorLight: colors.white
};
export default imageSlider;